(() => {
  const SOURCE_FORM = '#MobileDrawerLocalizeForm';
  const WRAPPER_CLASS = 'ttg-mobile-language';
  const PREVIEW_KEYS = ['preview_theme_id', '_fd', 'pb'];

  const preservePreviewContext = (form) => {
    const returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) return;

    const currentParams = new URLSearchParams(window.location.search);
    if (!PREVIEW_KEYS.some((key) => currentParams.has(key))) return;

    try {
      const returnUrl = new URL(returnInput.value || window.location.pathname, window.location.origin);
      PREVIEW_KEYS.forEach((key) => {
        if (currentParams.has(key)) {
          returnUrl.searchParams.set(key, currentParams.get(key));
        }
      });
      returnInput.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
    } catch (_) {
      // Keep Shopify's original return_to value if parsing fails.
    }
  };

  const buildSwitch = () => {
    if (document.querySelector(`.${WRAPPER_CLASS}`)) return;

    const sourceForm = document.querySelector(SOURCE_FORM);
    if (!sourceForm) return;

    const languageDetails = sourceForm.querySelector('#Details-DrawerLanguageSelector');
    if (!languageDetails) return;

    const languageLinks = [...languageDetails.querySelectorAll('.js-localize-item[data-value]')];
    if (languageLinks.length < 2) return;

    const currentLocale =
      sourceForm.querySelector('input[name="locale_code"]')?.value?.toLowerCase() || '';

    const newForm = sourceForm.cloneNode(false);
    newForm.id = 'TtgMobileHeaderLanguageForm';
    newForm.className = 'ttg-mobile-language__form';

    sourceForm.querySelectorAll('input[type="hidden"]').forEach((input) => {
      if (input.name !== 'locale_code') {
        newForm.appendChild(input.cloneNode(true));
      }
    });

    const wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;
    wrapper.setAttribute('aria-label', 'Language / Sprache');

    languageLinks.forEach((link) => {
      const locale = (link.dataset.value || '').toLowerCase();
      if (!locale || !['en', 'de'].includes(locale)) return;

      const button = document.createElement('button');
      button.type = 'submit';
      button.name = 'locale_code';
      button.value = locale;
      button.className = 'ttg-mobile-language__button';
      button.textContent = locale.toUpperCase();
      button.setAttribute('aria-label', link.textContent.trim());

      if (locale === currentLocale) {
        button.classList.add('is-active');
        button.setAttribute('aria-current', 'true');
      }

      newForm.appendChild(button);
    });

    if (!newForm.querySelector('button[name="locale_code"]')) return;

    preservePreviewContext(newForm);
    wrapper.appendChild(newForm);

    const drawer = sourceForm.closest('.mobile-draw') || sourceForm.closest('[data-drawer]');
    const nav = drawer?.querySelector('nav');

    if (nav) {
      nav.parentNode.insertBefore(wrapper, nav);
    } else {
      sourceForm.parentNode.insertBefore(wrapper, sourceForm);
    }

    const originalLanguageWrapper = languageDetails.closest('.localize__item__wrapper');
    if (originalLanguageWrapper) originalLanguageWrapper.hidden = true;
  };

  const init = () => {
    buildSwitch();
    const observer = new MutationObserver(buildSwitch);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
